module.exports = __webpack_public_path__ + "img/search_big.6938c43d.svg";